import DataUtils from '@/utils/DataUtils'
import * as Input from '@/components/base/atoms/input'
import * as CustomInput from '@/components/base/atoms/input/indexCustom'
import ObjArrUtils from '@/utils/ObjArrUtils'
import {
  VAutocomplete,
  VCombobox,
  VRangeSlider,
  VSlider,
  VSelect,
  VTextarea,
  VTextField,
} from 'vuetify/components'
import LetsCenterPicker from '@/components/autoImport/LetsCenterPicker.vue'

const compList = {
  VAutocomplete,
  VCombobox,
  VRangeSlider,
  VSlider,
  VSelect,
  VTextarea,
  VTextField,
  ...Input,
  // add custom Component Here (For Current Project)
  ...CustomInput,
  LetsCenterPicker
}

const basePresetList = {
  default: {
    column: 'col-md-4',
    component: 'VTextField',
    props: {}
  },
  section: {
    column: 'col-12',
    component: 'H2',
  },
  // input
  text: {
    column: 'col-md-4',
    component: 'VTextField',
  },
  textarea: {
    column: 'col-md-4',
    component: 'VTextarea',
  },
  number: {
    column: 'col-md-4',
    component: 'VTextField',
    props: {
      type: 'number'
    }
  },
  checkbox: {
    column: 'col-md-4',
    component: 'AtCheckbox',
  },
  switch: {
    column: 'col-md-4',
    component: 'AtSwitch',
  },
  radio: {
    column: 'col-md-4',
    component: 'AtRadio',
  },
  file: {
    column: 'col-md-4',
    component: 'AtFilePicker',
  },
  date: {
    column: 'col-md-4',
    component: 'AtDatePicker',
  },
  time: {
    column: 'col-md-4',
    component: 'AtTimePicker',
  },
  dateRange: {
    column: 'col-md-4',
    component: 'AtDateRangePicker',
  },
  select: {
    column: 'col-md-4',
    component: 'VSelect',
  },
  autoComplete: {
    column: 'col-md-4',
    component: 'VAutocomplete',
  },
  combobox: {
    column: 'col-md-4',
    component: 'VCombobox',
  },
  rangeSlider: {
    column: 'col-md-4',
    component: 'VRangeSlider',
  },
  slider: {
    column: 'col-md-4',
    component: 'VSlider',
  }
}

function baseCenterProps(ctx) {
  return {
    component: LetsCenterPicker,
    label: $this.$t('C10101.Edit.sent'),
    props: {
      placeholder: $this.$t('C10101.Edit.sentwoshitekudasai'),
      clearable: true,
      authorityMode: false,
      groupMode: false,
    }
  }
}


// add preset comps here (For Current Project)
function customPresetList(ctx) {
  return {
    //  select is not allowed
    select: {},
    autoComplete: {
      component: 'VAutocomplete',
      props: {
        placeholder: $this.$t('C10101.Table.shitekudasai'),
        variant: 'outlined',
        density: 'compact',
        clearable: true,
        'hide-details': "auto",
        'item-title': 'label',
        'item-value': 'value',
      }
    },
    combobox: {
      component: 'VCombobox',
      props: {
        placeholder: $this.$t('C10101.Table.shitekudasai'),
        variant: 'outlined',
        density: 'compact',
        clearable: true,
        'hide-details': "auto",
      }
    },
    letsCenter: baseCenterProps(ctx),
    letsCenterAuth: ObjArrUtils.merge(
      baseCenterProps(ctx), {
        props: {
          authorityMode: true,
        }
      }),
    letsCenterGroup: ObjArrUtils.merge(
      baseCenterProps(ctx), {
        props: {
          groupMode: true,
        }
      }),
    letsCenterAuthGroup: ObjArrUtils.merge(
      baseCenterProps(ctx), {
        props: {
          authorityMode: true,
          groupMode: true,
        }
      }),
  }
}

function PresetList(ctx) {
  return ObjArrUtils.merge(basePresetList, customPresetList(ctx))
}

const AtFormUtils = {
  compList,
  basePresetList,
  customPresetList,
  genField(key, obj, globalProps) {
    // [type,component,custom]
    // handle `label`
    if (obj.label) {
      obj.props = obj.props ?? {}
      obj.props.label = obj.label
      delete obj.label
    }
    if (obj.component) {
      return obj
    }
    if (obj.custom) {
      return { ...obj, component: obj.custom }
    }

    const type = obj.preset ?? obj.type ?? 'default'

    let targetPreset = basePresetList[type] ?? this.customPresetList[type]

    if (targetPreset === undefined) {
      console.warn(`AtForm Preset Not Found ${type}, use default preset`)
      targetPreset = basePresetList.default
    } else {
      targetPreset.label = key
    }

    const def = DataUtils.mergeObjects(targetPreset, obj)

    // apply global props
    def.props = DataUtils.mergeObjects(def.props, globalProps)
    return def
  }
}

export {
  AtFormUtils,
  PresetList,
}
